import React, {
    useState,
    useEffect,
} from 'react';
import { Link } from "react-router";
import { useQuery, useMutation } from '@tanstack/react-query';

import { getBasketData } from "../router"
import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";
import * as UTILS from "../utils";

import Ticket from './ticket';
import InstanceEventSummary from '../components/instance-event-summary';
import InstanceBasketSummary from '../components/instance-basket-summary';
import BackButton from '../components/back-button';
import LoadingIndicator from '../components/loading-indicator';


export default function EditTickets(props) {

    const [tickets, setTickets] = useState(null)
    const [removeTicketPending, setRemoveTicketPending] = useState(null)

    const continue_link = 
    CONSTANTS.HAS_TICKET_DONATIONS ?
        `/book-online/${CONSTANTS.INSTANCE.iframe_id}/ticket-donations` 
            : CONSTANTS.SUPPLEMENTARY_INSTANCES ? 
                `/book-online/${CONSTANTS.INSTANCE.iframe_id}/extras`
                    : "/basket";

    const { data: basketData, isPending: basketDataPending, isFetching: basketDataFetching } = getBasketData();

    const { 
        isPending: priceListDataPending,
        data: priceListData,
    } = useQuery({
        queryKey: ['priceListData', CONSTANTS.INSTANCE_ID],
        queryFn: () => QUERIES.getInstancePriceList(CONSTANTS.INSTANCE_ID),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 86400000,
        onError: (error) => {
            handleError(error.message, setNotification);
        },
    });
    

    useEffect(() => {
        if (!basketData || !basketData.tickets) return;

        const tickets_by_instance = UTILS.getTicketsByInstance(basketData.tickets);
        setTickets(tickets_by_instance);

    }, [basketData]);

    if (basketDataPending || basketDataFetching || removeTicketPending || priceListDataPending) return <LoadingIndicator type="page" />

    return (
        <div className='booking-pathway__container booking-pathway__edit-tickets'>
            <InstanceEventSummary />
            
            <div className='booking-pathway__main-content'>
                <h1 className='booking-pathway__header'>Edit tickets</h1>

                {tickets?.length ?
                    <ul className='select-ticket-type__list' role="list">
                        { tickets.map((ticket) => (
                            <li key={ticket.id}>
                                <Ticket ticket={ticket} setRemoveTicketPending={setRemoveTicketPending} pricelist={priceListData} />
                            </li>
                        ))}
                    </ul>
                : <p className='error-message'>There are no tickets in your basket</p>
                }
            </div>

            <InstanceBasketSummary />

            <div className='booking-pathway__footer'>
                {!tickets?.length ?
                    <div className='btn btn--primary disabled'>Continue</div>
                :
                    <Link to={continue_link} className='btn btn--primary' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Continue</Link>
                }
                <BackButton />            
            </div>
        </div>
    );
}
